module.exports = __webpack_public_path__ + "static/img/login4.057b82a2.png";